/**
 * Created by Ruslan Loboda on 8/7/2017.
 */

import actions from './actions'

export default {
	namespaced: true,
	actions
}



// WEBPACK FOOTER //
// ./src/vuex/services/city/index.js